module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0072.png.fc8c1eb2.jpg";